import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { requestDelete } from 'src/legacy_modules/server/request'

type LogoutResponse = {}

export const logout = async () => {
  if (IS_MOCK_MODE) {
    return
  }

  return await requestDelete<LogoutResponse>({
    url: `${SERVER_URL}/accounts/signout`,
    params: {},
  })
}
